<template>
  <div class="scroll_flex_container">
    <navbar title="行銷活動"></navbar>
    <!-- 可領取 -->
    <div class="coupons_container">
      <claimableCoupon v-for="(item, index) in storeCouponList" :key="index" :item="item" @claim="claimCoupon"
        @toPage="toClaimCouponPage"></claimableCoupon>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/general/navbar.vue";
// import commonUtils from "@/utils/common.utils";
import claimableCoupon from "../components/coupon/claimableCoupon.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    navbar,
    claimableCoupon
  },
  computed: {
    storeCode() {
      return this.$store.getters['userData/storeCode'];
    },
    ...mapGetters('coupon', {
      storeCouponList: 'storeCouponList',
    }),
    // storeCouponList() {
    //   return [{
    //     id: 1,
    //     title: 'test',
    //     description: 'test desc',
    //     usage_period_begin: '2024/12/12',
    //     usage_period_end: '2024/12/31'
    //   },
    //   {
    //     id: 1,
    //     title: 'test',
    //     description: 'test desc',
    //     usage_period_begin: '2024/12/12',
    //     usage_period_end: '2024/12/31'
    //   }]
    // }
  },
  async mounted() {
    try {
      await this.$store.dispatch('coupon/getStoreCoupons')
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    async claimCoupon(id) {
      console.log("領取優惠卷 id", id);
      await this.$store.dispatch('coupon/claimCoupon', id)
    },
    async toClaimCouponPage(id) {
      await this.$store.dispatch('coupon/getCouponInfo', id)
      // 點擊優惠卷時，進入領取頁面
      this.$router.push({
        path: `/${this.storeCode}/coupon/claim/${id}`,
      });
    },
  },
};
</script>
<style lang="scss">
.claim_button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 36px;
  background-color: #FBCB02;
  border-radius: 6px;
  border: none;
  color: #000;
  font-weight: 500;
  font-family: PingFang SC;
  font-size: 15px;
  flex-shrink: 0;
  margin-top: 5px;
}

.coupon_image {
  width: 120px;
  height: 100%;
  border-radius: 6px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 120px;
    border-radius: 6px;
    flex-shrink: 0;
  }
}

.coupons_container {
  -ms-overflow-style: none;
  scrollbar-width: none;
  height: 360px;
  width: 100%;
  margin-bottom: 20px;
}

.coupons_container ::-webkit-scrollbar {
  display: none;
}

.coupon_detail {
  flex-grow: 1;
  height: 100%;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  .coupon_title {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    margin: 0 0 8px;
  }

  .coupon_descrption {
    font-size: 16px;
    font-weight: 400;
    font-family: PingFang SC;
    color: #666666;
    width: 100%;
  }

  .event_duration {
    font-family: PingFang SC;
    font-size: 12px;
    white-space: nowrap;
    font-weight: 400;
    color: #666666;
    margin: 0;
  }

  .usage_duration {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: 400;
    color: #fa821b;
    margin: 0;
    width: 100%;
    text-align: right;
  }
}
</style>
